import React, { useState, cloneElement } from "react"
import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import { Button, Avatar, IconButton, Grid, Menu, MenuItem, Divider } from "@material-ui/core"
import Toolbar from "@material-ui/core/Toolbar"
import useScrollTrigger from "@material-ui/core/useScrollTrigger"
import logo from "@/assets/images/sparca-logo.png"
import { urlPath } from "@/utils"
import { useSelector, useDispatch } from "react-redux"
import { userLogoutRequest } from "@/redux/actions/userAction"
import { openDrawer, collapseDrawer } from "@/redux/actions/drawerAction"
import { useNavigate, Link as RouterLink } from "react-router-dom"
import useTopRoleIsAccountHolder from "@/hooks/useTopRoleIsAccountHolder"
import Box from "@material-ui/core/Box"
import { MenuOutlined } from "@material-ui/icons"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: "flex",
    },
    paper: {
        padding: theme.spacing(5, 4),
        margin: "auto",
        maxWidth: "100%",
        width: "100%",
    },
    appBar: {
        backgroundColor: "#ffffff",
        "& .right-side > *": {
            marginLeft: theme.spacing(2),
        },
        borderBottom: theme.palette.sparcaLightGrey.main,
    },
    popoverPaper: {
        [theme.breakpoints.up("sm")]: {
            marginTop: "45px",
        },
        marginTop: "30px",
    },
    linkedPrimary: {
        color: "#000000",
        "&:hover": {
            color: theme.palette.primary.main,
            background: "none",
        },
    },
    noDecoration: {
        textDecoration: "none",
    },
    logo: {
        margin: theme.spacing(1, 0),
    },
    helpLink: {
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "inline",
        },
    },
    sidebarMobile: {
        display: "inline-block",
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
    menuButtonIconClosed: {
        transition: theme.transitions.create(["transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        transform: "rotate(0deg)"
    },
    menuButtonIconOpen: {
        transition: theme.transitions.create(["transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        transform: "rotate(180deg)"
    },
    menuButton: {
        // width:'48px',
        // height: '48px'
    },
    logoWrapper: {
        display: "flex",
        gap: "4px",
        alignItems: "center",
    }
}))

function ElevationScroll(props) {
    const { children, window } = props
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    })

    return cloneElement(children, {
        elevation: trigger ? 4 : 0,
    })
}

const SidebarMobile = (props) => {
    const { handleClose, userId, topRoleIsAccountHolder } = props
    const classes = useStyles()

    return (
        <Box className={classes.sidebarMobile}>
            <RouterLink
                className={classes.noDecoration}
                to={topRoleIsAccountHolder ? urlPath("account-holder-main", userId) : urlPath("dashboard", userId)}
            >
                <MenuItem onClick={handleClose}>Home</MenuItem>
            </RouterLink>
            <RouterLink className={classes.noDecoration} to={urlPath("view-department", userId)}>
                <MenuItem onClick={handleClose}>View Department</MenuItem>
            </RouterLink>
            <RouterLink className={classes.noDecoration} to={urlPath("view-designation", userId)}>
                <MenuItem onClick={handleClose}>View Designation</MenuItem>
            </RouterLink>
        </Box>
    )
}
const Header = () => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)
    const userData = useSelector((state) => state.userReducer)
    const dispatch = useDispatch()
    const { drawerOpen } = useSelector((state) => state.drawerReducer)
    const navigate = useNavigate()
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleLogout = () => {
        setAnchorEl(null)
        dispatch(userLogoutRequest)
        navigate(urlPath("login"))
    }

    const handleDrawerToggle = () => {
        if (drawerOpen)
            return dispatch(collapseDrawer())
        dispatch(openDrawer())
    }



    const CCSiteURL = process.env.CC_MAIN_SITE
    const topRoleIsAccountHolder = useTopRoleIsAccountHolder(userData)
    return (
        <>
            <ElevationScroll>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Grid container direction="row" justify="space-between" alignItems="center">
                            <Grid style={{display:'flex', alignItems:"center"}} className="logo-section" item>
                                <IconButton
                                    aria-label="Open drawer"
                                    onClick={handleDrawerToggle}
                                    className={classes.menuButton}
                                >
                                    <MenuOutlined
                                    fontSize="default"
                                        classes={{
                                            root: drawerOpen
                                                ? classes.menuButtonIconOpen
                                                : classes.menuButtonIconClosed
                                        }}
                                    />
                                </IconButton>
                                <RouterLink
                                    to={
                                        topRoleIsAccountHolder
                                            ? urlPath("account-holder-main", userData.user.userId)
                                            : urlPath("dashboard", userData.user.userId)
                                    }
                                >
                                    <img className={classes.logo} src={logo} alt="sparca-logo" />
                                </RouterLink>
                            </Grid>
                            <Grid className="user-section" item>
                                <Button href={`${CCSiteURL}/products/dashboard-help/`} className={classes.helpLink}>
                                    Need Help?
                                </Button>
                                {userData.user ? (
                                    <>
                                        <IconButton aria-controls="simple-menu" aria-haspopup="true" size="small" onClick={handleClick}>
                                            <Avatar>
                                                {userData.user.firstName && userData.user.firstName[0]}
                                                {userData.user.lastName && userData.user.lastName[0]}
                                            </Avatar>
                                        </IconButton>
                                        <Menu
                                            id="option-dropdown-menu"
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                            PopoverClasses={{ paper: classes.popoverPaper }}
                                        >
                                            {/* <SidebarMobile
                                                topRoleIsAccountHolder={topRoleIsAccountHolder}
                                                handleClose={handleClose}
                                                userId={userData.user.userId}
                                            /> */}
                                            <RouterLink className={classes.noDecoration} to="/profile">
                                                <MenuItem onClick={handleClose}>Profile</MenuItem>
                                            </RouterLink>
                                            <RouterLink className={classes.noDecoration} to="/login">
                                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                            </RouterLink>
                                        </Menu>
                                    </>
                                ) : null}
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </ElevationScroll>
            <Toolbar />
            <Divider />
        </>
    )
}

export default Header
